import { periodBounds } from "./chart_timeline_aggregation"
import { paintNavSkeletonForVisit } from "./nav_instant_skeleton"

// Les points cliquables d'un graphe mènent tous à un index filtré : même destination,
// donc même squelette d'attente qu'un onglet de sidebar.
const SKELETON_VARIANT = "index"

export function buildChartIndexFilterUrl(config, bucket, granularity = "month") {
  if (!config?.indexPath || !config?.attribute) return null

  const { start, end } = periodBounds(bucket, granularity)
  const from = formatFilterDate(start)
  const to = formatFilterDate(end)
  const filterId = randomFilterId()
  const f = JSON.parse(JSON.stringify(config.scopeFilters || {}))

  const options = { f }

  if (config.dateScopeSql) {
    options.sql_queries = [
      {
        query: `( ${config.dateScopeSql} ) >= :from AND ( ${config.dateScopeSql} ) <= :to`,
        params: { from: `${from} 00:00:00`, to: `${to} 23:59:59.999999` }
      }
    ]
  } else {
    f[config.attribute] = {
      [filterId]: { o: "between", v: ["", from, to] }
    }
  }
  if (config.contextualAuthorizedGroups?.length) {
    options.contextual_authorized_groups = config.contextualAuthorizedGroups
  }

  const separator = config.indexPath.includes("?") ? "&" : "?"
  return `${config.indexPath}${separator}options=${encodeURIComponent(JSON.stringify(options))}#list`
}

export function visitChartIndexFilterUrl(url) {
  if (!url) return

  // Réaction immédiate au clic, avant même que la requête ne parte : l'index se paie les deux
  // mêmes allers-retours qu'un onglet (coquille puis `load=true`), et jusqu'ici l'écran restait
  // sur le tableau de bord pendant tout ce temps. Le lien de sidebar équivalent, lui, réagit —
  // d'où l'impression que les graphes ne répondaient pas.
  paintNavSkeletonForVisit(url, SKELETON_VARIANT)

  if (window.Turbo?.visit) {
    window.Turbo.visit(url, { frame: "_top" })
  } else {
    window.location.assign(url)
  }
}

export function formatFilterDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export function randomFilterId() {
  return String(Math.floor(Math.random() * 90_000) + 10_000)
}
